export const strategy = <T extends string | number | symbol, F>(
  record: Record<T, F>,
  status: T,
) => record[status];
